import React from 'react';
import classNames from 'classnames';
import LockedIcon from 'images/locked.svg';

import { AutoCloseToolTip } from '../OnClickToolTip/AutoCloseToolTip';

type Props = {
  loading: boolean;
  threshold: number;
  signed?: number;
  isFinalizing?: boolean;
  isFinalizedCurrentNonce?: boolean;
  isExecutedCurrentNonce?: boolean;
};

// TODO_R: move into QueuedTransactionsTabs/components/
// TODO_Y: [PN]
export const TransactionStatusLabel = ({
  loading,
  threshold,
  signed = 0,
  isFinalizing,
  isFinalizedCurrentNonce = false,
  isExecutedCurrentNonce = false,
}: Props) => {
  if (isExecutedCurrentNonce && isFinalizedCurrentNonce && !isFinalizing) {
    return (
      <div className="px-4 sm:px-8">
        <img src={LockedIcon} alt="" />
      </div>
    );
  }

  return (
    <>
      {loading ? (
        <AutoCloseToolTip
          tooltipContent={
            isFinalizing
              ? ''
              : 'This transaction was sent to the blockchain. To reject this processing and execute another one, you can still create and execute the conflict transaction with the higher gas fee.'
          }
          autoClosed={false}
        >
          <div className="flex items-center h-24">
            <span className="flex items-center justify-center gap-8 py-4 px-4 sm:px-8 rounded-[4px]">
              <img width={18} height={18} src="/loading-gif.gif" alt="" />
              {isFinalizing ? 'Finalizing' : 'Processing'}
            </span>
          </div>
        </AutoCloseToolTip>
      ) : (
        <div className="flex items-center h-24">
          <span
            className={classNames(
              'flex items-center justify-center gap-4 py-4 px-4 sm:px-8 rounded-[4px]',
              signed === threshold ? 'bg-success-10' : 'bg-warning-10'
            )}
          >
            {`${signed}/${threshold} confirmations`}
          </span>
        </div>
      )}
    </>
  );
};
